import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// SERVICES
import { getSingleIndividualPaymentsReportHistory, getSingleIndividualUnpaidOrders } from '../../services';

const styles = theme => ({
  orderStatusCardsContainer: {
    flexWrap: 'wrap',
    marginTop: 20,
    minHeight: 200,
  },

  unpaidTable: {
    textAlign: 'left',

    '& td:first-of-type': {
      width: 275,
    },
    '& h3': {
      margin: 0,
    },
  },

  paymentDetailTable: {
    textAlign: 'left',

    '& th:first-of-type': {
      width: 150,
    },
  },

  hr: {
    // width: '80%',
    alignSelf: 'stretch',
    // margin: 'auto',
    marginTop: 50,
    marginBottom: 0,
    height: 2,
    background: '#CCC',
  },
});

const QaDashboard = ({ classes }) => {
  const [expanded, setExpanded] = useState(null);
  const [unpaidOrders, setUnpaidOrders] = useState({
    results: null,
    loading: false,
    error: null,
  });
  const [history, setHistory] = useState({
    results: null,
    loading: false,
    error: null,
  });

  const getSingleIndividualPaymentsReportHistoryAsync = async () => {
    try {
      setHistory({
        ...history,
        results: null,
        loading: true,
        error: null,
      });
      const results = await getSingleIndividualPaymentsReportHistory([], 'QA');

      setHistory({
        ...history,
        results,
        loading: false,
        error: null,
      });
    } catch (error) {
      const errorMessage = error.message || 'An error occurred while fetching your payment history';
      setHistory({
        ...history,
        results: null,
        loading: false,
        error: errorMessage,
      });
    }
  };

  const getSingleIndividualUnpaidOrdersAsync = async () => {
    try {
      setUnpaidOrders({
        ...unpaidOrders,
        results: null,
        loading: true,
        error: null,
      });
      const results = await getSingleIndividualUnpaidOrders('QA');

      setUnpaidOrders({
        ...unpaidOrders,
        results,
        loading: false,
        error: null,
      });
    } catch (error) {
      const errorMessage = error.message || 'An error occurred while fetching your unpaid orders';
      setUnpaidOrders({
        ...unpaidOrders,
        results: null,
        loading: false,
        error: errorMessage,
      });
    }
  };

  useEffect(() => {
    getSingleIndividualPaymentsReportHistoryAsync();
    getSingleIndividualUnpaidOrdersAsync();
  }, []);

  return (
    <div className={cn('flex-1', 'col-start-start')}>
      <h1 className={cn('text-left')}>Next Payment</h1>
      {unpaidOrders && unpaidOrders.results && (
        <table className={classes.unpaidTable}>
          <thead>
            <tr>
              <td>Your uncompensated orders:</td>
              <td>
                <h3>{unpaidOrders.results.count}</h3>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Your uncompensated amount:</td>
              <td>
                <h3>${unpaidOrders.results.sum.toFixed(2)}</h3>
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {(!unpaidOrders || !unpaidOrders.results) && (
        <div style={{ margin: '20px auto 0 auto', width: '80%' }}>
          <div className={cn('text-neutral')} style={{ marginBottom: 10 }}>
            Please wait one moment while we gather your unpaid orders...
          </div>
          <LinearProgress />
        </div>
      )}

      <div className={classes.hr} />

      <div className={cn('col-start-start')} style={{ marginBottom: 20, marginTop: 20 }}>
        <h1 className={cn('text-left')} style={{ margin: 0 }}>
          Payment History
        </h1>
        <span className={cn('text-neutral')}>(showing the last 10 paid periods)</span>
      </div>
      {/* PAYMENT HISTORY */}
      {history &&
        history.results &&
        history.results.map((payment, paymentIndex) => {
          return (
            <ExpansionPanel
              key={paymentIndex}
              expanded={expanded === paymentIndex}
              onChange={() => setExpanded(expanded === paymentIndex ? null : paymentIndex)} // for toggling close as well
              style={{ width: '100%' }}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography style={{ flexBasis: '33.33%', textAlign: 'left' }}>Period: {payment.period}</Typography>
                <Typography>Period Total: {payment.paymentTotal}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {/* if any details exist, setup the headers of the table */}
                {payment.paymentOrderlineDetail && (
                  <React.Fragment>
                    <table className={classes.paymentDetailTable}>
                      <thead>
                        <tr>
                          <th>Order Line</th>
                          <th>Paid Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payment.paymentOrderlineDetail.map((pod, podIndex) => (
                          <tr key={podIndex}>
                            <td>
                              <Typography>{pod.orderlineId}</Typography>
                            </td>
                            <td>{pod.orderLineTotal}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </React.Fragment>
                )}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
      {(!history || history.loading) && (
        <div style={{ margin: '20px auto 0 auto', width: '80%' }}>
          <div className={cn('text-neutral')} style={{ marginBottom: 10 }}>
            Please wait one moment while your payment history is retrieved... Please wait one moment while we gather
            your unpaid orders...
          </div>
          <LinearProgress />
        </div>
      )}
      {!!history && !!history.results && !history.results.length && (
        <div className={cn('text-neutral')}>It looks like you do not have any pay history yet...</div>
      )}
    </div>
  );
};

QaDashboard.propTypes = {};

QaDashboard.defaultProps = {};

export default withStyles(styles)(QaDashboard);
// export {
//     Dashboard
// };
